export default __webpack_public_path__ + "static/186-44338c190dca68eb80e71bc5d82576c2.jpg";